module.exports = __webpack_public_path__ + "static/media/jakelee.3aad07a3.jpg";